import { css } from '@emotion/react'
import { useState } from 'react'
import { getWirkUrl } from '@definitions'
import { useAuth } from 'react-oidc-context'
import { openLink } from '@utils'
import { useParams } from 'react-router'
import { ProjectType } from '@types'
import { Loader } from '@components/utils'

import ProjectsTable from './ProjectsTable'
import Cards from './Cards'
import Header from './Header'

type ProjectsProps = {
  projectsAvailable: ProjectType[]
  isLoading?: boolean
}

const Projects = ({ projectsAvailable, isLoading }: ProjectsProps) => {
  const { user } = useAuth()

  const params = useParams()
  const [selectedValue, setSelectedValue] = useState(1)
  const onProjectClick = (project: ProjectType) => {
    if (project.isAccessibleToUser) {
      openLink(
        `${getWirkUrl('Form')}/contribute/${project.isReviewProject ? 'review' : 'project'}/${
          project.idProject
        }?token=${user.access_token}&tenant=${params.tenant}`,
      )
    }
  }

  return (
    <div>
      <Header selectedValue={selectedValue} setSelectedValue={setSelectedValue} />
      <div
        css={css`
          margin-top: 16px;
        `}
      >
        {isLoading && <Loader />}

        {!isLoading && Number(selectedValue) === 1 && (
          <Cards cards={projectsAvailable} onProjectClick={onProjectClick} />
        )}

        {!isLoading && Number(selectedValue) !== 1 && (
          <ProjectsTable
            projectsAvailable={projectsAvailable}
            tableProps={{
              onRow: (row) => ({
                style: {
                  backgroundColor: row.isAccessibleToUser ? 'white' : 'lightgray',
                },
                onClick: () => onProjectClick(row),
              }),
            }}
          />
        )}
      </div>
    </div>
  )
}

export default Projects
